export const BoostCredit = ({ className = "" }) => (
  <p className={`text-[11px] text-zinc-600 text-center ${className}`}>
    Designed &amp; Built by{" "}
    <a
      href="https://www.boostmarketing.agency"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="boost-credit-link"
      className="hover:text-zinc-400 transition-colors underline underline-offset-2 decoration-zinc-700"
    >
      Boost! Design &amp; Marketing Ltd
    </a>
  </p>
);

export default BoostCredit;
